/* eslint-disable
    camelcase,
    consistent-return,
    func-names,
    no-plusplus,
    no-return-assign,
    no-undef,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

'general.coffee';

// Avoid `console` errors in browsers that lack a console.

(function () {
  const noop = function () {};

  const methods = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd', 'timeStamp', 'trace', 'warn'];
  let {
    length,
  } = methods;
  const console = window.console || {};

  // Only stub undefined methods.
  while (length--) {
    console[methods[length]] = console[methods[length]] || noop;
  }

  if (!window.console) {
    return window.console = console;
  }
}());

$(() => {
  $('.mobile-nav .search-trigger').on('click', (e) => {
    e.preventDefault();
    return $('.mobile-nav form[action="/search"]').toggle(function () {
      const $this = $(this);
      if ($this.is(':visible')) {
        return $this.find(':text').focus();
      }
    });
  });

  let sidr_open = false;
  $('.side-menu-trigger').sidr({
    speed: 200,
    onOpen() {
      sidr_open = true;
      $('html').css({ overflow: 'hidden', position: 'fixed' });
      addSwipeToCloseListeners();
      return $('body').css({ overflow: 'hidden', position: 'static' });
    },
    onClose() {
      removeSwipeToCloseListeners();
      return sidr_open = false;
    },
  });

  let touchStartX = 0;
  let touchCurrentX = 0;
  let touchStartY = 0;
  let touchCurrentY = 0;
  let swipeThreshold = 100; // Threshold for closing the menu
  let verticalThreshold = 50; // Threshold for detecting vertical scroll
  let isSwiping = false;
  let isScrolling = false;

  function addSwipeToCloseListeners() {
    $('#sidr').on('touchstart', handleTouchStart);
    $('#sidr').on('touchmove', handleTouchMove);
    $('#sidr').on('touchend', handleTouchEnd);
  }
  
  function removeSwipeToCloseListeners() {
    $('#sidr').off('touchstart', handleTouchStart);
    $('#sidr').on('touchmove', handleTouchMove);
    $('#sidr').off('touchend', handleTouchEnd);
  }

  function handleTouchStart(e) {
    touchStartX = e.originalEvent.changedTouches[0].screenX;
    touchStartY = e.originalEvent.changedTouches[0].screenY;
    isSwiping = true;
    isScrolling = false; 
  }

  function handleTouchMove(e) {
    if (!isSwiping) return;
    touchCurrentX = e.originalEvent.changedTouches[0].screenX;
    touchCurrentY = e.originalEvent.changedTouches[0].screenY;
  
    // Calculate the swipe distance
    let swipeDistanceX = touchStartX - touchCurrentX;
    let swipeDistanceY = Math.abs(touchStartY - touchCurrentY); // Absolute value to detect any vertical movement

     // If vertical movement exceeds the threshold, assume it's a scroll
    if (swipeDistanceY > verticalThreshold) {
      isScrolling = true;
      return; // Ignore swipe and assume scrolling
    }
  
    // If the swipe distance exceeds the threshold, close the menu
    if (!isScrolling && swipeDistanceX > swipeThreshold) {
      if (sidr_open){
        $.sidr('toggle', 'sidr');
      }
      isSwiping = false; // Stop tracking after closing
    }
  }
  
  function handleTouchEnd(e) {
    isSwiping = false;
    isScrolling = false;
  }

  $('body').append('<div class="sidr-overlay"></div>');

  $(document).on('click', (e) => {
    if (sidr_open) {
      if (!$(e.target).closest('#sidr').length) {
        e.preventDefault();
      }
      $.sidr('toggle', 'sidr');
    const elem = $('#sidr')
    const tabbable = elem.find('select, input, textarea, button, a').filter(':visible');
    const firstTabbable = tabbable.first();
    const lastTabbable = tabbable.last();
    firstTabbable.focus();
    
    lastTabbable.on('keydown', function(e) {
        if (e.which === 9 && !e.shiftKey) {
            e.preventDefault();
            firstTabbable.focus();
        }
    });

    firstTabbable.on('keydown', function(e) {
        if (e.which === 9 && e.shiftKey) {
            e.preventDefault();
            lastTabbable.focus();
        }
    });

    elem.on('keyup', function(e) {
        if (e.keyCode === 27) {
            elem.hide();
        }
    });
return
    }
  });

  $('.side-menu-trigger').on('click', (e) => {
    if (!sidr_open) {
      e.preventDefault();
      return $.sidr('toggle', 'sidr');
    }
  });

  return $(window).on('orientationchange', () => $.sidr('close', 'sidr'));
});
